export default __webpack_public_path__ + "static/media/casquetteNike.a9d7f3b7.jpg";